import { IconBaseProps } from "react-icons";
import { HiOutlineCheck, HiOutlineExclamation, HiOutlineInformationCircle, HiOutlineX } from "react-icons/hi";
import { twMerge } from "tailwind-merge";
import { Slide, toast, ToastContainer as ToastifyContainer, ToastOptions, TypeOptions } from 'react-toastify';
import { delayShowToast } from "src/utils/constants";

interface ToastProps {
   message: React.ReactNode
   type: TypeOptions
}

const ToastContainer = () => {
   return (
      <ToastifyContainer
         autoClose={delayShowToast}
         closeButton={({ closeToast }: { closeToast?: () => void }) => (
            <button onClick={closeToast} aria-label="Close notification">
               <HiOutlineX size={20} color="#b8b8b8" className="hover:stroke-black" />
            </button>
         )}
         closeOnClick
         hideProgressBar
         newestOnTop={false}
         pauseOnFocusLoss
         pauseOnHover
         position="top-right"
         rtl={false}
         theme="light"
         toastStyle={{
            borderRadius: '6px',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
         }}
      />
   );
};

const Toast: React.FC<ToastProps> = ({ message, type }) => {
   const bgColor =
      type === 'default' || type == 'success'
         ? 'bg-[#31C48D]'
         : type === 'warning'
         ? 'bg-[#FACA15]'
         : type === 'error'
         ? 'bg-[#D03801]'
         : 'bg-[#1C64F2]';

   const iconProps: IconBaseProps = { size: 20, color: 'white', strokeWidth: 3 };

   const icon: React.ReactElement =
      type === 'default' || type == 'success' ? (
         <HiOutlineCheck {...iconProps} />
      ) : type === 'warning' ? (
         <HiOutlineExclamation {...iconProps} />
      ) : type === 'error' ? (
         <HiOutlineX {...iconProps} />
      ) : (
         <HiOutlineInformationCircle {...iconProps} />
      );

   return (
      <div className="flex items-center h-fit">
         <div className={twMerge('w-8 h-8 min-w-8 min-h-8 rounded-full flex justify-center items-center', bgColor)}>{icon}</div>
         <span className="text-[#111928] text-sm inline-block ml-2.5 pr-2.5">{message}</span>
      </div>
   );
};

const showToast = (type: TypeOptions, message: React.ReactNode, options?: ToastOptions) => {
   const role = options?.role ?? 'alert';
   return toast(() => <Toast message={message} type={type} />, { transition: Slide, icon: false, ...options, role });
};

// eslint-disable-next-line react-refresh/only-export-components -- showToast is imported by ~78 modules; splitting it out is a rename-only churn for a cosmetic HMR boundary
export { showToast };
export default ToastContainer